/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Illegal_Characters_HintInputs */

const en_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove illegal characters from the text.`)
};

const fr_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimez les caracteres illegaux du texte.`)
};

const de_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne unzulässige Zeichen aus dem Text.`)
};

const it_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi i caratteri illegali dal testo.`)
};

const ru_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите из текста недопустимые символы.`)
};

const es_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar caracteres ilegales del texto.`)
};

const zh_cn2_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从文本中删除非法字符。`)
};

const ja_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストから不正な文字を削除します。`)
};

const hi_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट से अवैध वर्णों को हटाएँ।`)
};

const pt_pt2_error_nav_illegal_characters_hint = /** @type {(inputs: Error_Nav_Illegal_Characters_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remova caracteres inválidos do texto.`)
};

/**
* | output |
* | --- |
* | "Remove illegal characters from the text." |
*
* @param {Error_Nav_Illegal_Characters_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_illegal_characters_hint = /** @type {((inputs?: Error_Nav_Illegal_Characters_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Illegal_Characters_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_illegal_characters_hint(inputs)
	if (locale === "de") return de_error_nav_illegal_characters_hint(inputs)
	if (locale === "it") return it_error_nav_illegal_characters_hint(inputs)
	if (locale === "ru") return ru_error_nav_illegal_characters_hint(inputs)
	if (locale === "es") return es_error_nav_illegal_characters_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_illegal_characters_hint(inputs)
	if (locale === "ja") return ja_error_nav_illegal_characters_hint(inputs)
	if (locale === "hi") return hi_error_nav_illegal_characters_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_illegal_characters_hint(inputs)
	return en_error_nav_illegal_characters_hint(inputs)
});